import useSWRMutationForm, { useErrorToSnackbar } from 'common-form/useSWRMutationForm';
import useApplicationUpdate from '../../resources/applications/update';

const useForm = () => {
  const onSubmit = () => ({
    application: { offer_accepted: true },
  });

  return useSWRMutationForm({
    useMutation: () => useApplicationUpdate(),
    onSubmit,
    useUnhandledError: useErrorToSnackbar,
  });
};

export default useForm;
